import { Badge } from '@mage-ui/components';
import { cx } from '@mage-ui/styled-system/css';
import { badge, courseRow, flexWrapper } from '@mage-ui/styled-system/recipes';

export const CourseRow = ({ data, children, ...props }) => {
  return (
    <div className={courseRow().root} {...props}>
      <div
        className={flexWrapper({
          align: 'start',
          alignM: 'center',
          direction: 'column',
          directionM: 'row',
          gap: 'gap200',
          gapM: 'gap800',
        })}
      >
        {data?.fields?.name ||
          (data?.name && (
            <div className={courseRow().contentWrapper}>
              {data?.fields?.iso ||
                (data?.iso && (
                  <abbr
                    title={data?.fields?.name || data?.name}
                    className={courseRow().title}
                  >
                    {data?.fields?.iso || data?.iso}
                  </abbr>
                ))}

              <Badge
                aria-hidden='true'
                classNames={{
                  root: cx(badge({ size: 's' }), courseRow().label),
                }}
              >
                {data?.fields?.name || data?.name}
              </Badge>
            </div>
          ))}
        <div className={courseRow().descriptionWrapper}>{children}</div>
      </div>
    </div>
  );
};
